import { DeletingState } from 'common/CommonConstants';
import { componentWithValuesSchema } from 'common/stack/ComponentWithValuesDocuments';
import { stackConfigSchema } from 'common/stack/StackConfigDocuments';
import { z } from 'zod';

export type ProjectDocument = z.infer<typeof ProjectDocumentSchema>;

export const ProjectDocumentSchema = z
  .object({
    id: z.number().int(),
    accountID: z.number().int(),
    accountName: z.string(),
    accountIdentifier: z.string(),
    name: z.string().min(1, 'Please enter a name'),
    tweakedDomainSlug: z
      .string()
      .min(1, 'Please enter a domain')
      .max(16, 'Domain is too long')
      .regex(/^[a-zA-Z0-9_-]*$/g)
      .nullable(),
    defaultDomain: z.string(),
    stackConfig: stackConfigSchema,
    componentsWithValues: z.array(componentWithValuesSchema),
    repositoryUrl: z.string().min(1).nullable(),
    repositoryRef: z.string().min(1).nullable(),
    deploymentCount: z.number().int(),
    deletingStateID: z.nativeEnum(DeletingState),
  })
  .strict();
